export const TRACKING_LABEL = {
    WHATS_APP: 'whatsapp',
    COPY_LINK: 'copyLink',
    EMAIL: 'email',
    CLOSE: 'Close',
};

export const UTM_SOURCE = {
    WHATS_APP: 'whatsapp',
    COPY_LINK: 'copyLink',
    MAIL: 'mail',
};
